export default {
  title: 'Nastavenia filtra',
  timeInterval: 'Časový interval',
  additionalFilters: 'Ďalšie filtre',
  noWeekdaysNotification: 'Musí byť vybraný aspoň jeden deň v týždni',
  lagging: {
    lagging: 'Oneskorenie',
    isLagging: {
      true: 'Iba detegované',
      false: 'Iba zastavené',
    },
    all: 'Detegované aj zastavené',
  },
  newState: 'Nový stav',
  assignee: 'Priradené k',
  created: 'Vytvorené',
};
